import { ActionsMenu } from '@/components/molecules'
import { Box, Button, HStack, Heading, Text, VStack } from '@chakra-ui/react'

export const Section = ({
  title,
  subTitle,
  actions,
  children,
  isLoading,
  action: {
    text: actionText,
    action,
    isLoading: isLoadingAction,
    isDisabled: isDisabledAction,
    ...actionProps
  } = {},
  ...props
}) => {
  return (
    <VStack bg={'primary.0'} p={4} rounded={'md'} boxShadow={'base'} {...props}>
      <HStack
        flexDir={['column', 'row']}
        w={'full'}
        justifyContent={'space-between'}
        alignItems={'stretch'}
        mb={children && 4}
      >
        <Box>
          <Heading as="h2" size="lg">
            {title}
          </Heading>

          {subTitle && (
            <Text as={Box} py={2} maxW={'container.sm'}>
              {subTitle}
            </Text>
          )}
        </Box>

        {!isLoading && (
          <Box>
            <ActionsMenu actions={actions} />

            {action && (
              <Button
                isLoading={isLoadingAction}
                variant={'solid'}
                onClick={action}
                isDisabled={isDisabledAction}
                {...actionProps}
              >
                {actionText}
              </Button>
            )}
          </Box>
        )}
      </HStack>

      {children}
    </VStack>
  )
}
